<script setup lang="ts">
import type { StripeElements, StripePaymentElementChangeEvent } from "@stripe/stripe-js";
import SkeletonLoader from "@/components/shared/loaders/BaseSkeletonLoader.vue";

interface StripeReadyEvent {
  elementType: string;
}

const STRIPE_ELEMENT_TYPE = "payment";

defineProps({
  formLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["ready", "detailsComplete", "paymentType"]);

const detectPaymentReady = (event: StripeReadyEvent): void => {
  emit("ready", true);
};

const detectStripeElementsChange = (event: StripePaymentElementChangeEvent): void => {
  emit("detailsComplete", event.complete);
  emit("paymentType", event.value.type);
};

const mountPayment = (stripeElements: StripeElements | undefined): void => {
  if (!stripeElements) {
    return;
  }
  const paymentElement = stripeElements.create(STRIPE_ELEMENT_TYPE);
  if (paymentElement) {
    paymentElement.on("ready", detectPaymentReady);
    paymentElement.on("change", detectStripeElementsChange);
    paymentElement.mount("#payment-element");
  }
};

defineExpose({ mountPayment });
</script>
<template>
  <section>
    <!-- Display a payment form -->
    <form id="payment-form">
      <skeleton-loader v-if="formLoading" />
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
      <div id="payment-message" class="hidden"></div>
    </form>
    <!-- Display a payment form -->
  </section>
</template>
